import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ onLogoClick }) => {  // Add onLogoClick prop
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('home');
  const [activeService, setActiveService] = useState('');
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Set active link based on current path
    const currentPath = location.pathname;
    console.log('Current Path:', currentPath); // Debug log

    if (currentPath === '/') {
      setActiveLink('home');
      setActiveService('');
    } else if (currentPath.includes('/about')) {
      setActiveLink('about');
      setActiveService('');
    } else if (currentPath.includes('/portfolio')) {
      setActiveLink('portfolio');
      setActiveService('');
    } else if (currentPath.includes('/expertise')) {
      setActiveLink('expertise');
      setActiveService('');
    } else if (currentPath.includes('/contact')) {
      setActiveLink('contact');
      setActiveService('');
    } else if (currentPath.includes('/services') ||
      currentPath.includes('/softwaredevelopment') ||
      currentPath.includes('/mobiledevelopment') ||
      currentPath.includes('/ecommercedevelopment') ||
      currentPath.includes('/websitedevelopment') ||
      currentPath.includes('/digitalmarketing') ||
      currentPath.includes('/branding') ||
      currentPath.includes('/3danimations') ||
      currentPath.includes('/educationalconsultancy')) {
      setActiveLink('services');

      // Set active service based on current path
      if (currentPath.includes('/softwaredevelopment')) setActiveService('softwaredevelopment');
      else if (currentPath.includes('/mobiledevelopment')) setActiveService('mobiledevelopment');
      else if (currentPath.includes('/ecommercedevelopment')) setActiveService('ecommercedevelopment');
      else if (currentPath.includes('/websitedevelopment')) setActiveService('websitedevelopment');
      else if (currentPath.includes('/digitalmarketing')) setActiveService('digitalmarketing');
      else if (currentPath.includes('/branding')) setActiveService('branding');
      else if (currentPath.includes('/3danimations')) setActiveService('3danimations');
      else if (currentPath.includes('/educationalconsultancy')) setActiveService('educationalconsultancy');
      else setActiveService('');
    } else {
      setActiveLink('home');
      setActiveService('');
    }
  }, [location]);

  // Handle logo click
  const handleLogoClick = (e) => {
    e.preventDefault();
    const currentPath = location.pathname;
    if (currentPath === '/') {
      if (onLogoClick) {
        onLogoClick();
      }
    } else {
      navigate('/');
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMobileServicesOpen(false);
  };

  const toggleServices = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const toggleMobileServices = () => {
    setIsMobileServicesOpen(!isMobileServicesOpen);
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setActiveService('');
    closeMobileMenu();
  };

  const handleServiceClick = (serviceKey) => {
    setActiveLink('services');
    setActiveService(serviceKey);
    closeMobileMenu();
    setIsServicesOpen(false);
  };

  const services = [
    { name: 'Software Development', path: '/softwaredevelopment', key: 'softwaredevelopment' },
    { name: 'Mobile App Development', path: '/mobiledevelopment', key: 'mobiledevelopment' },
    { name: 'E-commerce Development', path: '/ecommercedevelopment', key: 'ecommercedevelopment' },
    { name: 'Website Development', path: '/websitedevelopment', key: 'websitedevelopment' },
    { name: 'Digital Marketing', path: '/digitalmarketing', key: 'digitalmarketing' },
    { name: 'Branding', path: '/branding', key: 'branding' },
    { name: '3D-Animations', path: '/3danimations', key: '3danimations' },
    { name: 'Educational Consultancy', path: '/educationalconsultancy', key: 'educationalconsultancy' }
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 0);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <header className="navbar">
        <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}> {/* Add click handler and cursor pointer */}
          <img src="/images/header2-logo.webp" alt="Desktop Logo" className="logo-desktop" />
          <img src="/images/oakya-it-services.webp" alt="Mobile Logo" className="logo-mobile" />
        </div>

        {/* Hamburger Button */}
        <div className="hamburger" id="hamburger" onClick={toggleMobileMenu}>
          ☰
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-links" id="nav-links">
          <Link
            to="/"
            className={activeLink === 'home' ? 'active' : ''}
            onClick={() => handleLinkClick('home')}
          >
            Home
          </Link>
          <Link
            to="/about"
            className={activeLink === 'about' ? 'active' : ''}
            onClick={() => handleLinkClick('about')}
          >
            About Us
          </Link>
          {/* Services Dropdown */}
          <div
            className="dropdown"
            onMouseEnter={() => setIsServicesOpen(true)}
            onMouseLeave={(e) => {
              const relatedTarget = e.relatedTarget;
              if (relatedTarget == null || !(relatedTarget instanceof Node) || !e.currentTarget.contains(relatedTarget)) {
                setIsServicesOpen(false);
              }
            }}
          >
            <div className={`dropdown-wrapper ${activeLink === 'services' ? 'active' : ''}`}>
              <button
                className={`dropbtn ${activeLink === 'services' ? 'active' : ''}`}
                onClick={toggleServices}
                onMouseEnter={() => setIsServicesOpen(true)}
              >
                Services ▾
              </button>
            </div>
            <div
              className={`dropdown-content ${isServicesOpen ? 'show' : ''}`}
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              {services.map((service, index) => (
                <Link
                  key={index}
                  to={service.path}
                  className={activeService === service.key ? 'active-sub' : ''}
                  onClick={() => handleServiceClick(service.key)}
                >
                  {service.name}
                </Link>
              ))}
            </div>
          </div>
          <Link
            to="/expertise#expertise"
            className={activeLink === 'expertise' ? 'active' : ''}
            onClick={() => handleLinkClick('expertise')}
          >
            Expertise
          </Link>
          <Link
            to="/portfolio"
            className={activeLink === 'portfolio' ? 'active' : ''}
            onClick={() => handleLinkClick('portfolio')}
          >
            Portfolio
          </Link>
          <Link
            to="/contact"
            className={activeLink === 'contact' ? 'active' : ''}
            onClick={() => handleLinkClick('contact')}
          >
            Contact
          </Link>
        </nav>
      </header>

      {/* Mobile Slide Menu */}
      <aside id="mobileMenu" className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <button id="mobileClose" className="mobile-close" onClick={closeMobileMenu}>
          ✕
        </button>
        <ul className="mobile-nav">
          <li>
            <Link
              to="/"
              className={activeLink === 'home' ? 'active' : ''}
              onClick={() => handleLinkClick('home')}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className={activeLink === 'about' ? 'active' : ''}
              onClick={() => handleLinkClick('about')}
            >
              About Us
            </Link>
          </li>
          <li className="mobile-services-item">
            <button
              className={`mobile-toggle ${activeLink === 'services' ? 'active' : ''}`}
              onClick={toggleMobileServices}
            >
              Services {isMobileServicesOpen ? '▴' : '▾'}
            </button>
            <ul className={`mobile-sub ${isMobileServicesOpen ? 'open' : ''}`}>
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.path}
                    className={activeService === service.key ? 'active-sub' : ''}
                    onClick={() => handleServiceClick(service.key)}
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          <li>
 <Link
              to="/expertise"
              className={activeLink === 'expertise' ? 'active' : ''}
              onClick={() => handleLinkClick('expertise')}
            >
              Expertise
            </Link>
            </li>
           <li>
            <Link
              to="/portfolio"
              className={activeLink === 'portfolio' ? 'active' : ''}
              onClick={() => handleLinkClick('portfolio')}
            >
              Portfolio
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className={activeLink === 'contact' ? 'active' : ''}
              onClick={() => handleLinkClick('contact')}
            >
              Contact
            </Link>
          </li>
        </ul>
      </aside>

      {/* Overlay */}
      <div
        id="overlay"
        className={`overlay ${isMobileMenuOpen ? 'open' : ''}`}
        onClick={closeMobileMenu}
      ></div>
    </>
  );
};

export default Navbar;